import useSWRMutation from 'swr/mutation';
import baseFetcher from '../../shared/baseFetcher';
import useMe from '../../me';

const fetcher = (key) => baseFetcher({ ...key, method: 'POST' });

const useSendMFA = () => {
  const { data: { id } } = useMe();
  return useSWRMutation(
    { url: `/auth/identities/${id}/mfa/resend-verification` },
    fetcher,
  );
};

export default useSendMFA;
